<template>
  <div class="card-margin" v-if="isShow">
    <div class="form" >
      <div class="queryCon">
        <div class="queryItem">
          <label class="labelTitle">{{!isPromotion ? '条件商品:' : '促销商品:'}}</label>
          <inputSearch
            @selected='addGoods'
            :loading='goodsloading'
            @getData='handleInputSearch'
            style="width:256px"
            :selectedList='goodsForm'
            :data='goodsData'
            :columns='goodsColumns'
            v-if="able"
          >
          </inputSearch>
          <div class="radioBatch">
            <label>适用批次:</label>
            <lk-radio-group vertical v-model="batch" @on-change='handlerRadioChange'>
              <lk-radio label="1" :disabled='storeId == 0 || !able || disabledBath'>
                <span>全部批次</span>
              </lk-radio>
              <lk-radio label="2" :disabled='storeId == 0 || !able || disabledBath'>
                <span>部分批次</span>
              </lk-radio>
            </lk-radio-group>
          </div>
        </div>
      </div>
    </div>
    <lk-table border :columns='columns' :data='goodsForm'></lk-table>
  </div>
</template>
<script>
import mapState from '@/mixins/mapState';
import utils from '../../libs/utils';
import InputSearch from '@/components/InputSearch.vue';
import sale from '@/services/sale';

export default {
  name: 'addPromotionGoods',
  mixins: [mapState],
  components:{
    InputSearch
  },
  props: {
    storeId: {
      type: [Number, String],
    },
    isPromotion: {
      type: Boolean,
      default: false,
    },
    able: {
      type: Boolean,
      default: false,
    },
    isShow: {
      type: Boolean,
      default: true,
    },
    goodsFormalList: {
      type: Array,
    },
    goodsGiveList: {
      type: Array,
    },
    value: {
      type: Array,
    },
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  watch: {
    value: {
      handler() {
        if (this.value.length) {
          if (this.value[0].batchSeq && this.value[0].batchSeq != '') {
            this.batch = '2';
          } else {
            this.value[0].batchSeqs=['全部批次']
          }
          this.goodsForm = this.value;
        }
      },
      deep: true,
    },
  },
  computed: {
    isShowSelect() {
      return this.able && this.storeId != 0 && this.batch != 1;
    }
  },
  data() {
    return {
      batch: '1',
      goodsData: [],
      goodsloading: false,
      disabledBath: false,
      goodsForm: [],
      columns: [
        {
          type: 'index',
          width: 56,
          align: 'center'

        },
        { title: '商品编码', key: 'drugSerialCode' },
        {
          title: '指定批次',
          width: 263,
          key: 'drugSerialCode',
          render: (h, params) => {
            const seqList = [];
            params.row.goodsBatchSeqInfoList.forEach((item) => {
              const tempDate = utils.formatDate(item.expiryDate);
              seqList.push({ name: `批次:${item.batchSeq}  有效期:${tempDate}  可售数量:${item.num}`, value: item.batchSeq });
            });
            const optionData = this.storeId == 0 || params.row.inventoryNum == 0 || this.batch == 1 ? ['全部批次'] : seqList || [];
            const optionArr = optionData.map(item => h('lk-option', {
              props: {
                value: item.value,
                key: item.value,
                label: item.name,
              },
            }, item));
            // 库存为0也显示全部批次
            // 如果不是全部门店，不是详情页，库存不为0，不是部分批次
            const tempBool = this.isShowSelect && params.row.inventoryNum != 0;
            return tempBool ? h('lk-select',
              {
                props: {
                  value: seqList || '',
                  placeholder: '请选择',
                  transfer: true,
                  multiple: true,
                },
                on: {
                  'on-change': (value) => {
                    this.goodsForm[params.index].batchSeqs = value;
                    this.$emit('change', this.goodsForm);
                  },
                },
              }, optionArr) : this.storeId == 0 || this.batch == 1 ? h('span', '全部批次') : h('span', params.row.batchSeq)
          },
        },
        { title: '商品类型', key: 'goodsTypeName' },
        { title: '通用名', key: 'approvedDrugNames' },
        { title: '商品名', key: 'goodsName' },
        { title: '规格', key: 'specifications' },
        { title: '包装单位', key: 'drugMiniPackageUnit' },
        { title: '生产厂家', key: 'manufacturer' },
        {
          title: '剂型',
          key: 'dosageFormName',
          render: (h, { row }) => h('span', row.dosageFormName || row.dosageForm)
        },
        {
          title: '操作',
          key: 'addBtn',
          render: (h, params) => {
            return h('lk-button', {
              props: {
                type: 'text',
                disabled: !this.able,
              },
              on: {
                click: () => {
                  const index = params.row._index;
                  this.goodsForm.splice(index, 1);
                },
              },
            }, '删除');
          },
        },
      ],
      goodsColumns: [
        { title: '商品编码', key: 'drugSerialCode', width: '80px' },
        { title: '药品通用名', key: 'name', width: '120px' },
        { title: '规格', key: 'spec', width: '90px' },
        { title: '包装单位', key: 'drugMiniPackageUnit', width: '65px' },
        { title: '有效期', key: 'expire', width: '84px' },
        { title: '生产厂家', key: 'producer', width: '120px' },
        { title: '库存', key: 'inventoryNum', width: '65px' },
        { title: '销售单价', key: 'retailPrice', width: '65px' },
      ],
    }
  },
  methods: {
    activeTypeChange(type) {
      if (type != 1) {
        this.batch = '1';
        this.disabledBath = true;
      } else {
        this.disabledBath = false;
      }
    },
    handlerRadioChange(val) {
      if (val == 2 && this.goodsForm.length) {
        if (this.goodsForm[0].inventoryNum == 0) {
          this.$Message.warning('此商品暂无库存，无法指定批次');
        } else {
          this.goodsForm[0].batchSeqs = [];
        }
      } else if(val == 1 && this.goodsForm.length) {
        this.$set( this.goodsForm[0], 'batchSeqs', ['全部批次']);
      }
    },
    addGoods(val) {
      if (this.goodsForm.length === 1) {
        this.$Message.warning('只能添加一个条件/促销商品');
        return;
      }
      const drugInfo = val.inventoryInfo;
      drugInfo.inventoryNum = val.inventoryNum;
      drugInfo.goodsTypeName = val.inventoryInfo.goodsType ? this.$store.state.publicParams.sgoodsTypes[val.inventoryInfo.goodsType] : val.inventoryInfo.goodsTypeName;
      drugInfo.goodsBatchSeqList = val.goodsBatchSeqList;
      drugInfo.goodsBatchSeqInfoList = val.goodsBatchSeqInfoList || [];
      drugInfo.batchSeqs = ['全部批次'];
      this.goodsForm.push(drugInfo);
      this.$emit('change', this.goodsForm);
    },
    handleInputSearch(val) {
      this.goodsloading = true;
      this.goodsData = [];
      sale.listStoreGoods({
        nameMix: val,
        storeId: this.storeId,
        isPromote: this.isPromotion ? 1 : 2,
      }).then((res) => {
        if (res.data.status === 200) {
          if (res.data.data && res.data.data.length) {
            res.data.data.forEach((item) => {
              let result = item;
              result.types = [];
              result.name = result.inventoryInfo.approvedDrugNames;
              result.spec = result.inventoryInfo.specifications;
              result.batch = result.inventoryInfo.goodsBatchNumber;
              result.expire = utils.formatDate(result.inventoryInfo.goodsExpiryDate);
              result.producer = result.inventoryInfo.manufacturer;
              result.drugMiniPackageUnit = result.inventoryInfo.drugMiniPackageUnit;
              result.drugMiniPackageUnitCode = result.inventoryInfo.drugMiniPackageUnitCode;
              result.inventoryNum > 1 ? (result.goodsCount = 1) : (result.goodsCount = result.inventoryNum);
              result.retailPrice = result.retailPrice;
              result.countryOfOrigin = result.inventoryInfo.countryOfOrigin;
              result.goodsLot = result.inventoryInfo.goodsBatchNumber;
              result.expireDate = result.inventoryInfo.goodsExpiryDate;
              result.drugSerialCode = result.inventoryInfo.drugSerialCode;
              result.inventoryInfo.isEphedrineDrugs === 1 && result.types.push('Ephedrine');
              result.isThirdEquipment === 1 && result.types.push('ThirdEquipment');
              (result.inventoryInfo.goodsExpiryDate - new Date().getTime()) <= 2592000000 && result.types.push('Expire');
              result.bottomPrice = result.retailPrice > result.maxPriceWithTax ? result.maxPriceWithTax : result.retailPrice;
              result.inventoryInfo.isMultiPrice === 1 && (result.disabled = true); // 营销活动多价格商品禁止选择 
              this.goodsData.push(result);
            });
          }
        } else {
          this.$Message.error(res.data.error);
        }
        this.goodsloading = false;
      }).catch((err) => {
        utils.handleError(err);
        this.goodsloading = false;
      });
    },
  },
  created() {
  },
  mounted() {
  },
};
</script>
<style lang="less" scoped>
/deep/ .ivu-radio-group {
  display: flex;
  margin-left: 20px;
}
.radioBatch {
  display: flex;
  align-items: center;
  margin-left: 100px;
}
/deep/ .ivu-table-wrapper {
  .ivu-table{
    .ivu-table-header {
      > table {
        >thead {
          >tr:first-child {
            .ivu-table-column-center{
              .ivu-table-cell {
                span {
                  display: none;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
